"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTenantFromUrl = void 0;

var getTenantFromUrl = function getTenantFromUrl() {
  if (typeof window !== 'undefined') {
    var _ref = process || {},
        _ref$env = _ref.env;

    _ref$env = _ref$env === void 0 ? {} : _ref$env;
    var _ref$env$REACT_APP_DO = _ref$env.REACT_APP_DOMAIN,
        REACT_APP_DOMAIN = _ref$env$REACT_APP_DO === void 0 ? '' : _ref$env$REACT_APP_DO;

    var _ref2 = window || global.window || {},
        _ref2$location = _ref2.location;

    _ref2$location = _ref2$location === void 0 ? {} : _ref2$location;
    var _ref2$location$hostna = _ref2$location.hostname,
        hostname = _ref2$location$hostna === void 0 ? '' : _ref2$location$hostna;

    if (!hostname) {
      return global.window.localStorage.getItem('tenantName');
    }

    var stripped = "".concat(hostname.replace(REACT_APP_DOMAIN, ''), ".");
    return stripped.substr(0, stripped.indexOf('.'));
  }

  return '';
};

exports.getTenantFromUrl = getTenantFromUrl;